export type DragPayload = {
  label: string
  icon?: string
  iconImage?: string
  groupId: string
  connectorId?: string
  dataSourceId?: number
}

const CONNECTOR_SHORT_TITLE: Record<string, string> = {
  postgresql: 'Postgres',
  mysql: 'MySQL',
  mariadb: 'MariaDB',
  oracle: 'Oracle',
  sql: 'SQL',
  excel: 'Excel',
  s3: 'S3',
  hadoop: 'Hadoop',
  servicenow: 'ServiceNow',
  zendesk: 'Zendesk',
  salesforce: 'Salesforce',
  mongodb: 'MongoDB',
  redis: 'Redis',
  neo4j: 'Neo4j',
  cassandra: 'Cassandra',
  union: 'Union',
  join: 'Join',
  split: 'Split',
  findreplace: 'Find and Replace',
  pivot: 'Pivot',
  edit: 'Edit',
  datetime: 'Date / Time',
  filter: 'Filter',
}

export function cardTitleFromPayload(payload: DragPayload): string {
  const cid = payload.connectorId
  if (cid) {
    const t = CONNECTOR_SHORT_TITLE[cid]
    if (t !== undefined) return t
  }
  return payload.label
}

export function assetKeyFromPayload(payload: DragPayload): string {
  const title = cardTitleFromPayload(payload)
  const slug = title
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
  const role =
    payload.groupId === 'sources'
      ? 'source'
      : payload.groupId === 'destinations'
        ? 'destination'
        : payload.groupId === 'integrations'
          ? 'integration'
          : payload.groupId === 'transformations'
            ? 'transform'
            : 'asset'
  const num = Math.floor(100 + Math.random() * 900)
  return `${slug}_${role}_${num}`
}

export function duplicateAssetKey(
  titleLine: string,
  groupId: string | undefined,
  currentAssetKey?: string
): string {
  const slug = titleLine
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
  const role =
    groupId === 'sources'
      ? 'source'
      : groupId === 'destinations'
        ? 'destination'
        : groupId === 'integrations'
          ? 'integration'
          : groupId === 'transformations'
            ? 'transform'
            : 'asset'
  const suffixMatch = currentAssetKey?.match(/_(\d+)$/)
  const num = suffixMatch ? Number.parseInt(suffixMatch[1], 10) + 1 : Math.floor(100 + Math.random() * 900)
  return `${slug}_${role}_${num}`
}

export function cardHeaderLabel(groupId: string | undefined): string {
  switch (groupId) {
    case 'sources':
      return 'Source'
    case 'destinations':
      return 'Destination'
    case 'integrations':
      return 'Integration'
    case 'transformations':
      return 'Transformation'
    default:
      return 'Source'
  }
}
